import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import PrepaymentsTable from './PrepaymentsTable';

const PrepaymentsPage = (): JSX.Element => {
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader hostsList titleId={'prepayments.prepayments'} showBreadcrumb />
                <PrepaymentsTable />
            </div>
        </PaddedLayout>
    );
};

export default PrepaymentsPage;
